 /** @type {{
  * category:string
  * description?:string
  * forEach? : "modifier" | "function" | "storage" | "require" | "if-condition" | "comprasion"
  * subtasks?:{
  *           id: string
  *           title:string
  *           automated?:number
  *           usingSimplifier?:number
  *           usingSimulator?:boolean
  *           hardToFind?:boolean
  *           }[]
  * }[]}
 */
module.exports.tasks=[
  
  {
    category:'Conditions (>,<,>=,<=,==)',
    description:`Developers often use the wrong comparison operators (>,<,>=,<=) by mistake. The auditor has the responsibility of reviewing and listing every instance of a comparison operator used in the smart contract and verifying that the developers have used the correct comparison operator.`,
    forEach:"comprasion",
    subtasks:[
      {id: 'correctOperator', title:'For each comparison operator the auditor should ask is it the correct operator?',usingSimplifier:1,}
    ]
  },
  {
    category:'Storage',
    subtasks:[
      {id: 'storageMissng', title:'Check that there is no storage that is missing that should exists',usingSimplifier:1}
    ]
  },
  {
    category:'For each storage',
    forEach:'storage',
    subtasks:[
      {id: 'storageNameTypos', title:'There is no typos in the storage name?.',usingSimplifier:1,automated:2},
      {id: 'storageNameSimilar', title:'There are no two storage with similar name?.',usingSimplifier:1,automated:2},
      
      {id: 'readOnlyReport', title:'If it is read-only report it as something that cannot change',usingSimplifier:1},
      {id: 'changeFuncChanging', title:'Check that every function that should change it - is changing it',usingSimplifier:1},
      {id: 'readFuncReading', title:'Check that every function that should read it - is reading it',usingSimplifier:1},
      {id: 'funcNotUsingStorage', title:'Check that the storage is not used by function that does not need it',usingSimplifier:1},
      {id: 'storageDescClear', title:'Is the storage clearly describe what it does',usingSimplifier:1},
      {id: 'changeStoragePermission', title:'Check who have permission to change this storage',usingSimplifier:1},
    ]
  },
  {
    category:'Modifiers',
    subtasks:[
      {id: 'modifierNameTypos', title:'There is no typos in the modifier name?.',usingSimplifier:1,automated:2},
      {id: 'modifierMissing', title:'Do you think there is any modifier that is missing? It is necessary to have at least a modifier for each type of user (role and permission) who will be using the smart contract.',usingSimplifier:1}
    ]
  },
  {
    category:'For each modifier',
    forEach:'modifier',
    description:'One of the most important things to audit on smart contracts is the Solidity Modifiers. All modifiers should be reviewed by the auditor, and the following questions should be asked',
    subtasks:[
      { id: 'modifierDescClear', title:"Does the modifier name clearly describe what it does?",usingSimplifier:1},
      { id: 'modifierCodeShort', title:"Is the modifier code short (usually 2 lines of code), and do you understand exactly what it does?",usingSimplifier:1,automated:2},
      { id: 'modifierAlterStorage', title:"Have you confirmed that the modifier does not alter the storage?",automated:2,usingSimplifier:1},
      { id: 'modifierCallExternalContract', title:"Have you confirmed that the modifier does not call to external smart contract?",usingSimplifier:1,automated:2},
      { id: 'modifierEmitsEvents', title:"Have you confirmed that the modifier does not emitting events?",usingSimplifier:1,automated:2},
      { id: 'modifierSimilarName', title:"Have you confirmed that there are not several modifiers with similar names?",automated:2,usingSimplifier:1},
      { id: 'modifierReadOneStorageVar', title:"Have you confirmed that the modifier does not read more than one storage variable? If there is an exception, ensure that it is documented in the specification.",usingSimplifier:1,automated:2},
      { id: 'modifierUserWhereNeeded', title:"Is the modifier used in every place where it is needed in the smart contract? Check all public functions.",usingSimplifier:2},
      { id: 'modifierNotUsedWhereNoNeed', title:"Have you confirmed that the modifier not appear in functions that are not in need of this modifier?",usingSimplifier:2},
      { id: 'modifierContainsParams', title:"If the modifier contains params, is it used seem correctly?",usingSimplifier:1},
      { id: 'modifierContainsCorrectParams', title:"If the modifier contains params, is the correct paramer passed to them?",usingSimplifier:1},
    ]
  },
  {
    category:'Events',
    description:`There are many developers who fail to pay sufficient attention to the events part of smart contracts. The smart contract must use events appropriately in order to ensure that all Web3 clients are able to make use of the smart contract.
    Events are used to inform the outside world (off-chain) that something has occurred in the smart contract. Therefore, every change to smart contract storage should result in an event.
    The auditor should list all the events of the smart contract and all the places where they are emitted and then answer the following questions.`,    
    subtasks:[
      {id: 'eventTriggeredWithWritableStorageVar', title:'Ensure that an event is triggered every time writable storage variables are changed. This can be an existing event type, or a new event type should be added to the smart contract.'}
    ]
  },
  {
    category:'For each event',
    subtasks:[
      {id: 'eventNameDescOccured', title:"Does the event name clearly describe what just occurred?",usingSimplifier:1},
      {id: 'eventNameTypos', title:'There is no typos in the event name?.',usingSimplifier:1,automated:2,},
      {id: 'eventParamDesc', title:"Does the name of each event parameter clearly describe its purpose?",usingSimplifier:1},
      {id: 'eventPramsOrder', title: "Is every call to the event is using the correct parametrs in the correct order?",usingSimplifier:1},
      {id: 'eventSignatureStandard', title:"If the event is a standard event (like ERC20, Transfer event), does the signature follow the standard?  (Make sure that the indexed parameters are also checked).",usingSimplifier:1},
      {id: 'eventCustom', title:"If the event is a custom event, does the parameters are defined as \"indexed\" to the greatest extent possible?",usingSimplifier:1},
      {id: 'eventTriggeredCorrect', title:"Is the event being triggered everywhere it should be?",usingSimplifier:1},
      {id: 'eventMultiTriggered', title:"Is it sure that the same event is not triggered twice for the same data?",usingSimplifier:1},
      {id: 'eventNameDesc', title:'Check that event name clearly describe what it does', },
      {id: 'eventForModifiableStorage', title:'Check that there is an event defiend for each modifiable storage',automated:2},
      {id: 'eventSimilarName', title:'Check that there is no several events with similar names'}
    ]
  },
  {
    category:'Functions',
    description:`We only care about public functions. Since those function are the ones that are callable by users or by smart contracts.
    Before starting those tasks, you have to use the Simplifer to collect all the public functions, and review their functionality. 
    `,
  },
  {
    category:'For each function',
    forEach:'function',
    subtasks:[
        {id: 'functionNameDesc', title:"Does the function name clearly describe what it does?",usingSimplifier:1},
        {id: 'functionNameTypos', title:'There is no typos in the function name?.',usingSimplifier:1,automated:2},
        {id: 'functionModifierParams', title:"Is the function is using the correct modifiers with the correct params?",usingSimplifier:1},
        {id: 'functionSignature', title:"If it's part of a standard, it the function signature defined correctly?",usingSimplifier:1},
        {id: 'functionParamDesc', title:"Is the parameters clearly describe their meaning?",usingSimplifier:1},
        {id: 'functionShouldWork', title:"Read the Solidity code and confirm that the function should work",usingSimplifier:2,hardToFind:true},
        {id: 'functionNameCorrect', title:"Is the function name following naming best-practice? (camelCase)?",automated:2},
        {id: 'functionReversible', title:"Is it reversible?",usingSimplifier:2},
        {id: 'functionRunAllowed', title:'Confirm that only who allowed to run this function is able to call it',usingSimplifier:1},
        {id: 'functionPass', title:'Test the function against 3 values that should make this function to pass',usingSimulator:true},
        {id: 'functionFail', title:'Test the function against 3 values that should make this function to fail',usingSimulator:true},
        {id: 'functionVarStorageName', title:'Function variable is not shadowing storage with similar name',usingSimulator:true,automated:2},
        {id: 'functionParamStorageName', title:'Function param is not shadowing storage with similar name',usingSimulator:true,automated:2},
      ]
  },
  {
    category:'Sandwitch attack',
    forEach:"function",
    subtasks:[
      {id: 'functionManipulate', title:'If this function manipulate the state ensure that it-safe to use the previous state just before ahead',hardToFind:true},
      {id: 'approveOrIncrease', title:'approve/increaseApproval',automated:2}
    ]
  },
  {
    category:'Back-running',
    forEach:"function",
    subtasks:[
      {id: 'functionManipulate', title:'If this function manipulate the state ensure that it-safe to use the previous state just before ahead',hardToFind:true},
      {id: 'approveOrIncrease', title:'approve/increaseApproval',automated:2}
    ]
  },
  {
    category:'Front-running',
    forEach:"function",
    subtasks:[
      {id: 'functionManipulate', title:'If this function manipulate the state ensure that it-safe to use the previous state just before ahead',hardToFind:true},
      {id: 'approveOrIncrease', title:'approve/increaseApproval',automated:2}
    ]
  },

  {
    category:'Reentrancy',
    subtasks:[
      {id: 'stateCall', title:'Check that state does not change before using address. call',automated:2,hardToFind:true },
      {id: 'stateSend', title:'Check that state does not change before using address. send',automated:2,hardToFind:true },
      {id: 'stateTransfer', title:'Check that state does not change before using address. transfer',automated:2,hardToFind:true },
    ]
  },
  {
    category:'Compilation',
    subtasks:[
      {id: 'ensureLatest', title:'Ensure the latest.',automated:2 },
      {id: 'ensureOptimization', title:'Ensure same optimization flags.' },
    ]
  },
  {
    category:'Crisis Management',
    subtasks:[
      {id: 'pauseSmartContract', title:'Is is possible to pause the smart contain using a master account?',usingSimplifier:1 },
    ]
  },
  {
    category:'Code Quality',
    subtasks:[
      {id: 'notTooLongFunction', title:'Is there are not too long functions?',usingSimplifier:0,automated:2 },
      {id: 'notTooNestedFunction', title:'Is there are not too nested functions?',usingSimplifier:0,automated:2 },
    ]
  },
  {
    category:'Documented',
    subtasks:[
      {id: 'codeDocumented', title:'Is the document documented enough?',usingSimplifier:0 },
    ]
  },
  {
    category:'Safe destruct',
    subtasks:[
      {id: 'selfDesctuctFunction', title:'Confirm that the smart contract does not contain self-descrtuct functions?',usingSimplifier:1 ,automated:2},
    ]
  },
  {
    category:'unsafe tx.origin',
    subtasks:[
      {id: 'txOriginVarUse', title:'Confirm that the smart contract does not use tx.origin variable',usingSimplifier:1 ,automated:2},
    ]
  },
  {
    category:'Time manipulation',
    subtasks:[
      {id: 'controlOfMiner', title:'Confirm that the control of the miner against block.number does not risk the smart contract',usingSimplifier:1 ,automated:1},
      {id: 'noBlockTimestampVar', title:'Confirm that the smart contract does not use block.timestamp variable',usingSimplifier:1 ,automated:2},
    ]
  },
  {
    category:'Bad randomness',
    subtasks:[
      {id: 'noRandom', title:'Confirm that the smart contract does not use random that can be manipulated by miner',usingSimplifier:1},
      {id: 'randomConfirm', title:'If the smart contract needs random values confirm it\s randomness',usingSimplifier:1 ,automated:2},
    ]
  },
  {
    category:'Attacks using smart-contract',
    subtasks:[
      {id: 'noBypass', title:'Ensure that every requirement in the smart contract cannot bypassed if smart contract is calling it.',usingSimplifier:1 ,automated:2,hardToFind:true},
    ]
  },
  {
    category:'Frozen value',
    subtasks:[
      {id: 'releaseTokens', title:'Ensure the smart contract can release tokens sent to it.',usingSimplifier:1,usingSimulator:true,automated:1 },
      {id: 'payableFunctions', title:'If there area payable functions ensure smart contract can release Ether sent to it.',usingSimplifier:1,usingSimulator:true,automated:1},
      {id: 'receiveFunctions', title:'If there area receive functions ensure smart contract can release Ether sent to it.',usingSimplifier:1,usingSimulator:true,automated:1},
    ]
  },
  {
    category:'Denial of service',
    subtasks:[
      {id: 'whileLoopInfinite', title:'Ensure there are not while-loop that goes into infinite value.',usingSimplifier:1,automated:2, },
      {id: 'forLoopInfinite', title:'Ensure the are not for-loop that goes into infinite value.',usingSimplifier:1,automated:2},
      {id: 'noExternalCallInsideLoop', title:'Ensure there is not call to external smart contract inside for-loop.',usingSimplifier:1,automated:2},
      {id: 'noExternalSendInsideLoop', title:'Ensure there is not send to external smart contract inside for-loop.',usingSimplifier:1,automated:2},
      {id: 'noExternalTransferInsideLoop', title:'Ensure there is not transfer to external smart contract inside for-loop.',usingSimplifier:1,automated:2},
    ]
  },
  {
    category:'Following specification',
    subtasks:[
      {id: 'noRequirement', title:'Read the specification and ensure there is no requirement that not provided by the smart contract.',usingSimulator:true, },
    ]
  },
  {
    category:'Following  standards',
    subtasks:[
      {id: 'erc20Standard', title:'If it is an ERC20 token ensure it is matching the ERC20 standard.',automated:2, },
      {id: 'erc721Standard', title:'If it is an ERC721 token ensure it is matching the ERC20 standard.',automated:2, },
      {id: 'erc1155Standard', title:'If it is an ERC1155 token ensure it is matching the ERC20 standard.',automated:2, },
    ]
  },
  {
    category:'Price manipulation',
    subtasks:[
      {id: 'erc20Liquidity', title:'If it is an ERC20 ensure users able to add it to the liqudity.',automated:2,usingSimulator:true },
      {id: 'erc20Uniswap', title:'If it is an ERC20 ensure users are able to switch it using UniSwap.',automated:2, },
    ]
  },
  {
    category:'UniSwap intergration',
    subtasks:[
      {id: 'erc20Liquidity', title:'If it is an ERC20 ensure users able to add it to the liqudity.',automated:2,usingSimulator:true },
      {id: 'erc20Uniswap', title:'If it is an ERC20 ensure users are able to switch it using UniSwap.',automated:2, },
    ]
  },
  {
    category:'OpenSea intergration',
    subtasks:[
      {id: 'erc721Opensea', title:'If it is an ERC721 users are able to sell and buy it on OpenSea.',automated:2,usingSimulator:true },
    ]
  },
  {
    category:'MakerDAO intergration',
    subtasks:[
      {id: 'erc20Colletorall', title:'If it is an ERC20 users are able to put it as colletorall.',automated:2,usingSimulator:true },
      {id: 'erc20Borrow', title:'If it is an ERC20 users are able to borrow it.',automated:2,usingSimulator:true },
    ]
  },
  {
    category:'Conflict between fallback and receive functionality',
    subtasks:[
      {id: 'cannotHave', title:'Cannot have...',automated:2,usingSimulator:true },
    ]
  },
]

/**
Reply attacks
Upgradability
Grefing
Proxy-Upgradability
// inline assembly
//block hash
// no return
// Function with similars selector
// Shadowing
// result not used
// delete in a dynamic array
// If it is an upgrade ensure the storage layout does not change
// Floating solidity version
// Outdated Solidity
// No hard coded ethereum addresses
// Check wrong address
// Things that related to ACL and proxy and transfer-proxy and storage-layouts
// avoid using now (Efficiency)
// Efficiency: pull over push (ether)
// Efficiency: pull over push (tokens)
// Functions with too many storage changes. (It what cost money)
Check all “require” statements in the smart contracts
// Using address that does not exists (transfer to someone who not exists, or tokens to someone that not want to receive...)
*/

